/* Zenvixo Motion Luxe engine. Works with Horizon's desktop scroll container (.page-wrapper) and window scroll on mobile. */
(function () {
  'use strict';
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = de.classList.contains('shopify-design-mode') || !!(w.Shopify && w.Shopify.designMode);
  function desk() { return w.innerWidth >= 990; }
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ---------- Scroll container detection ---------- */
  var scroller = null;
  function pickScroller() {
    var pw = $('.page-wrapper');
    scroller = (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) ? pw : null;
  }
  function getY() { return scroller ? scroller.scrollTop : w.scrollY; }
  function getMax() { return scroller ? scroller.scrollHeight - scroller.clientHeight : de.scrollHeight - w.innerHeight; }

  /* ---------- First-visit loader ---------- */
  var loaderClosed = false;
  function loaderDone() {
    if (loaderClosed || !de.classList.contains('zv-first')) return;
    loaderClosed = true;
    de.classList.add('zv-ready');
    try { sessionStorage.setItem('zv-seen', '1'); } catch (e) {}
  }
  if (de.classList.contains('zv-first')) {
    var t0 = performance.now();
    var fin = function () { setTimeout(loaderDone, Math.max(0, 1500 - (performance.now() - t0))); };
    if (d.readyState === 'complete') fin(); else w.addEventListener('load', fin);
    setTimeout(loaderDone, 2600);
  }

  /* ---------- Page transition origin ---------- */
  d.addEventListener('pointerdown', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    try { sessionStorage.setItem('zv-vt', (e.clientX / w.innerWidth * 100).toFixed(1) + '% ' + (e.clientY / w.innerHeight * 100).toFixed(1) + '%'); } catch (err) {}
  }, { passive: true });

  /* ---------- Scroll loop ---------- */
  var lastY = 0, vel = 0, ticking = false, scrollHandlers = [];
  function frame() {
    ticking = false;
    var y = getY(), max = getMax();
    de.style.setProperty('--zv-p', max > 0 ? (y / max).toFixed(4) : 0);
    de.classList.toggle('zv-scrolled', y > 40);
    vel += y - lastY; lastY = y;
    for (var i = 0; i < scrollHandlers.length; i++) { try { scrollHandlers[i](y); } catch (e) {} }
  }
  function onScroll(e) {
    if (e && e.target && e.target !== d && e.target !== scroller && e.target !== de && e.target !== d.body) return;
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }
  d.addEventListener('scroll', onScroll, { passive: true, capture: true });
  w.addEventListener('resize', function () { pickScroller(); onScroll(); });

  /* ---------- Reveal observer ---------- */
  var io = ('IntersectionObserver' in w) ? new IntersectionObserver(function (entries) {
    var batch = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (el.classList.contains('zv-card-anim')) el.style.setProperty('--zv-delay', (batch++ * 0.09).toFixed(2) + 's');
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;
  function observe(el) {
    if (el.classList.contains('is-in')) return;
    if (!io || reduce || design) { el.classList.add('is-in'); return; }
    io.observe(el);
  }

  function splitWords(el) {
    if (el.getAttribute('data-zv-split-done')) return false;
    var nodes = el.childNodes;
    for (var i = 0; i < nodes.length; i++) { if (nodes[i].nodeType !== 3 && nodes[i].nodeName !== 'BR') return false; }
    var html = '', idx = 0;
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.nodeType !== 3) { html += '<br>'; return; }
      n.textContent.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { html += ' '; return; }
        html += '<span class="zv-w"><span style="--wi:' + (idx++) + '">' + esc(p) + '</span></span>';
      });
    });
    if (!idx) return false;
    el.innerHTML = html;
    el.setAttribute('data-zv-split-done', '1');
    el.setAttribute('data-zv-split', '');
    return true;
  }

  /* ---------- Tilt + magnetic ---------- */
  function initTilt(scope) {
    if (!fine || reduce) return;
    $$('product-card .card-gallery, .product-card .card-gallery, .zv-sc__media', scope).forEach(function (g) {
      if (g.getAttribute('data-zv-tilt')) return;
      g.setAttribute('data-zv-tilt', '1');
      g.classList.add('zv-tilt');
      g.addEventListener('pointermove', function (e) {
        var r = g.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        g.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
        g.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
      });
      g.addEventListener('pointerleave', function () { g.style.setProperty('--ry', '0deg'); g.style.setProperty('--rx', '0deg'); });
    });
  }
  function initMagnetic(scope) {
    if (!fine || reduce) return;
    $$('.zv-btn, .zv-magnetic, .zv-hm__arrow, .zv-fm__top-btn', scope).forEach(function (b) {
      if (b.getAttribute('data-zv-mag')) return;
      b.setAttribute('data-zv-mag', '1');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + (x * 0.22).toFixed(1) + 'px,' + (y * 0.32).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Parallax ---------- */
  var parallaxEls = [];
  function initParallax(scope) {
    if (reduce) return;
    $$('.zv-split__media img, [data-zv-parallax]', scope).forEach(function (el) { if (parallaxEls.indexOf(el) < 0) parallaxEls.push(el); });
  }
  scrollHandlers.push(function () {
    var vh = w.innerHeight;
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      if (!el.isConnected || !el.parentElement) continue;
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      var f = parseFloat(el.getAttribute('data-zv-parallax')) || 0.1;
      el.style.transform = 'translate3d(0,' + (c * -f * r.height).toFixed(1) + 'px,0)';
    }
  });

  /* ---------- Cursor ---------- */
  function initCursor() {
    if (!fine || reduce || design || $('.zv-cursor')) return;
    var ring = d.createElement('div'); ring.className = 'zv-cursor'; ring.setAttribute('aria-hidden', 'true');
    ring.innerHTML = '<span class="zv-cursor__label">View</span>';
    var dot = d.createElement('div'); dot.className = 'zv-cursor-dot'; dot.setAttribute('aria-hidden', 'true');
    d.body.appendChild(ring); d.body.appendChild(dot);
    var label = ring.firstChild, mx = -200, my = -200, rx = -200, ry = -200, shown = false;
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; rx = mx; ry = my; de.classList.add('zv-has-cursor'); }
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      var t = e.target; if (!t || !t.closest) return;
      var card = t.closest('product-card, .product-card, .zv-sc__card, .zv-tile');
      var link = t.closest('a, button, [role=button], label, summary, .zv-hm__dot');
      var hide = !!t.closest('input, textarea, select, iframe, dialog[open], .shopify-payment-button');
      ring.classList.toggle('is-view', !!card && !hide);
      ring.classList.toggle('is-link', !card && !!link);
      ring.classList.toggle('is-hidden', hide); dot.classList.toggle('is-hidden', hide);
      if (card) label.textContent = card.matches('.zv-tile, .zv-sc__card') ? 'Explore' : 'View';
    }, { passive: true });
    de.addEventListener('mouseleave', function () { de.classList.remove('zv-has-cursor'); shown = false; });
    (function loop() {
      rx = lerp(rx, mx, 0.17); ry = lerp(ry, my, 0.17);
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Smooth scroll (Lenis, desktop pointer only, follows the active scroll container) ---------- */
  var lenisMode = null;
  function makeLenis() {
    if (!w.Lenis) return;
    if (w.zvLenis) { try { w.zvLenis.destroy(); } catch (e) {} w.zvLenis = null; }
    var opts = {
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      prevent: function (n) { return !!(n && n.closest && n.closest('dialog, [data-lenis-prevent], .menu-drawer, details[open], predictive-search-component, .facets')); }
    };
    if (scroller) { opts.wrapper = scroller; opts.content = scroller; }
    w.zvLenis = new w.Lenis(opts);
    lenisMode = scroller ? 'pw' : 'win';
  }
  function initLenis() {
    if (!fine || reduce || design || de.getAttribute('data-zv-smooth') === 'false') return;
    var s = d.createElement('script');
    s.src = 'https://unpkg.com/lenis@1.1.13/dist/lenis.min.js';
    s.async = true;
    s.onload = function () {
      makeLenis();
      function raf(t) { if (w.zvLenis) w.zvLenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      w.addEventListener('resize', function () { if ((scroller ? 'pw' : 'win') !== lenisMode) makeLenis(); });
      setInterval(function () {
        var l = w.zvLenis; if (!l) return;
        var locked = !!d.querySelector('dialog[open]') || de.hasAttribute('scroll-lock');
        if (locked && !l.isStopped) l.stop(); else if (!locked && l.isStopped) l.start();
      }, 200);
    };
    d.head.appendChild(s);
  }

  /* ---------- Hero: liquid slideshow ---------- */
  function initHero(scope) {
    $$('.zv-hm', scope).forEach(function (h) {
      if (h.getAttribute('data-zv-init')) return;
      h.setAttribute('data-zv-init', '1');
      var slides = $$('.zv-hm__slide', h), dots = $$('.zv-hm__dot', h), n = slides.length, cur = 0, busy = false;
      function go(i, ev) {
        if (busy || n < 2) return;
        i = (i + n) % n; if (i === cur) return;
        busy = true;
        var prev = slides[cur], next = slides[i];
        slides.forEach(function (s) { s.classList.remove('is-prev'); });
        prev.classList.remove('is-active'); prev.classList.add('is-prev');
        if (ev && ev.clientX != null && ev.detail !== 0) {
          var r = h.getBoundingClientRect();
          next.style.setProperty('--cx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          next.style.setProperty('--cy', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        } else { next.style.removeProperty('--cx'); next.style.removeProperty('--cy'); }
        next.classList.add('is-active');
        if (!reduce) {
          next.classList.add('is-entering');
          var fa = d.getElementById('zv-liquid-anim');
          if (fa && fa.beginElement) { try { fa.beginElement(); } catch (e) {} }
        }
        dots.forEach(function (dt, k) { dt.classList.toggle('is-active', k === i); dt.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        cur = i;
        setTimeout(function () { next.classList.remove('is-entering'); prev.classList.remove('is-prev'); busy = false; }, reduce ? 60 : 1650);
      }
      dots.forEach(function (dt, k) {
        dt.addEventListener('click', function (e) { go(k, e); });
        dt.addEventListener('animationend', function (e) { if (e.animationName === 'zv-line' && dt.classList.contains('is-active')) go(cur + 1); });
      });
      var pv = $('.zv-hm__arrow--prev', h), nx = $('.zv-hm__arrow--next', h);
      if (pv) pv.addEventListener('click', function (e) { go(cur - 1, e); });
      if (nx) nx.addEventListener('click', function (e) { go(cur + 1, e); });
      h.addEventListener('mouseenter', function () { h.classList.add('is-paused'); });
      h.addEventListener('mouseleave', function () { h.classList.remove('is-paused'); });
      h.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
      var sx = null;
      h.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') sx = e.clientX; }, { passive: true });
      h.addEventListener('pointerup', function (e) { if (sx == null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
      if (fine && !reduce) {
        h.addEventListener('pointermove', function (e) {
          var r = h.getBoundingClientRect();
          h.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * -26).toFixed(1) + 'px');
          h.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * -18).toFixed(1) + 'px');
        });
      }
      if (io) new IntersectionObserver(function (es) { h.classList.toggle('is-off', !es[0].isIntersecting); }).observe(h);
      if (!reduce) scrollHandlers.push(function () {
        var r = h.getBoundingClientRect();
        if (r.bottom < 0) return;
        h.style.setProperty('--sp', clamp(-r.top / r.height, 0, 1).toFixed(3));
      });
    });
  }

  /* ---------- Horizontal showcase ---------- */
  function initShowcase(scope) {
    $$('.zv-sc', scope).forEach(function (sc) {
      if (sc.getAttribute('data-zv-init')) return;
      sc.setAttribute('data-zv-init', '1');
      var track = $('.zv-sc__track', sc), curEl = $('.zv-sc__cur', sc), cards = $$('.zv-sc__card', sc), imgs = $$('.zv-sc__media img', sc), dist = 0;
      function update() {
        var p;
        if (sc.classList.contains('is-pinned')) {
          var r = sc.getBoundingClientRect();
          p = clamp(-r.top / (dist || 1), 0, 1);
          sc.style.setProperty('--zv-tx', (-p * dist).toFixed(1) + 'px');
        } else {
          var m = track.scrollWidth - track.clientWidth;
          p = m > 0 ? track.scrollLeft / m : 0;
        }
        sc.style.setProperty('--zv-scp', p.toFixed(3));
        var idx = Math.min(cards.length, Math.round(p * (cards.length - 1)) + 1);
        if (curEl) curEl.textContent = (idx < 10 ? '0' : '') + idx;
        if (!reduce) imgs.forEach(function (im) {
          var rr = im.parentElement.getBoundingClientRect();
          im.style.setProperty('--px', (((rr.left + rr.width / 2) - w.innerWidth / 2) / w.innerWidth * -50).toFixed(1) + 'px');
        });
      }
      function measure() {
        if (desk() && !reduce && !design && cards.length > 2) {
          sc.classList.add('is-pinned');
          dist = Math.max(0, track.scrollWidth - w.innerWidth);
          sc.style.height = (w.innerHeight + dist) + 'px';
        } else {
          sc.classList.remove('is-pinned'); sc.style.height = ''; dist = 0; sc.style.removeProperty('--zv-tx');
        }
        update();
      }
      scrollHandlers.push(update);
      track.addEventListener('scroll', update, { passive: true });
      w.addEventListener('resize', measure);
      w.addEventListener('load', measure);
      measure(); setTimeout(measure, 900);
    });
  }

  /* ---------- Statement ---------- */
  function initStatement(scope) {
    if (reduce || design) return;
    $$('.zv-st__text', scope).forEach(function (t) {
      if (t.getAttribute('data-zv-init')) return;
      t.setAttribute('data-zv-init', '1');
      var ws = $$('.zv-sw', t);
      scrollHandlers.push(function () {
        var r = t.getBoundingClientRect(), vh = w.innerHeight;
        if (r.bottom < -80 || r.top > vh + 80) return;
        var p = clamp((vh * 0.82 - r.top) / (r.height + vh * 0.3), 0, 1);
        var lit = Math.round(p * ws.length);
        for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('is-lit', i < lit);
      });
    });
  }

  /* ---------- Marquee velocity ---------- */
  var mqTracks = [], mqRunning = false, mqBoost = 1, mqLast = 1;
  function mqTick() {
    var target = 1 + Math.min(Math.abs(vel) / 14, 4);
    vel *= 0.86;
    mqBoost = lerp(mqBoost, target, 0.08);
    if (Math.abs(mqBoost - mqLast) > 0.01) {
      mqLast = mqBoost;
      for (var i = 0; i < mqTracks.length; i++) {
        var t = mqTracks[i];
        if (!t.isConnected || !t.getAnimations) continue;
        var an = t.getAnimations();
        for (var k = 0; k < an.length; k++) an[k].playbackRate = mqBoost;
      }
    }
    requestAnimationFrame(mqTick);
  }
  function initMarquee(scope) {
    $$('.zv-mq__track', scope).forEach(function (t) { if (mqTracks.indexOf(t) < 0) mqTracks.push(t); });
    if (!mqRunning && mqTracks.length && !reduce) { mqRunning = true; requestAnimationFrame(mqTick); }
  }

  /* ---------- Product page ---------- */
  function initProduct(scope) {
    $$('add-to-cart-component button, .add-to-cart-button, button[name=add], .product-form__submit', scope).forEach(function (b) { b.classList.add('zv-liquid'); });
  }

  /* ---------- Back to top ---------- */
  function initTopBtn(scope) {
    $$('[data-zv-top]', scope).forEach(function (b) {
      if (b.getAttribute('data-zv-init')) return;
      b.setAttribute('data-zv-init', '1');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (w.zvLenis) { w.zvLenis.scrollTo(0, { duration: 1.8 }); return; }
        (scroller || w).scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Cart: free UK delivery progress + header bump ---------- */
  var SHIP = (w.zvShip && w.zvShip.threshold) || 5000;
  function money(c, cur) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP', minimumFractionDigits: (c % 100 === 0 ? 0 : 2) }).format(c / 100); }
    catch (e) { return '£' + (c / 100).toFixed(2); }
  }
  function placeBar(box, before) {
    var bar = $('.zv-ship', box);
    if (!bar) {
      bar = d.createElement('div');
      bar.className = 'zv-ship'; bar.setAttribute('role', 'status');
      bar.innerHTML = '<div class="zv-ship__msg"></div><div class="zv-ship__bar" aria-hidden="true"><span class="zv-ship__fill"></span></div>';
      if (before && before.parentNode) before.parentNode.insertBefore(bar, before); else box.insertBefore(bar, box.firstChild);
    }
    return bar;
  }
  function renderShip(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var bars = [];
    var dlg = $('cart-drawer-component dialog, dialog.cart-drawer, .cart-drawer dialog, .cart-drawer__dialog');
    if (dlg) {
      var inner = dlg.firstElementChild && dlg.firstElementChild.tagName !== 'SCRIPT' ? dlg.firstElementChild : dlg;
      var head = $('.cart-drawer__header', dlg);
      bars.push(placeBar(inner, head ? head.nextElementSibling : null));
    }
    var main = $('#MainContent');
    if (main && main.getAttribute('data-template') === 'cart') {
      var form = $('form[action*="/cart"]', main);
      if (form) bars.push(placeBar(form.parentNode, form));
    }
    var t = cart.total_price, left = SHIP - t, pct = clamp(t / SHIP * 100, 0, 100), done = left <= 0 && cart.item_count > 0;
    var msg = cart.item_count === 0 ? 'Free UK delivery on orders over <b>' + money(SHIP, cart.currency) + '</b>'
      : done ? '<b>You’ve unlocked free UK delivery</b> ✦'
      : 'You’re <b>' + money(left, cart.currency) + '</b> away from free UK delivery';
    bars.forEach(function (bar) {
      var was = bar.classList.contains('is-done');
      bar.querySelector('.zv-ship__msg').innerHTML = msg;
      bar.style.setProperty('--zv-ship', pct.toFixed(1) + '%');
      bar.classList.toggle('is-done', done);
      if (done && !was) { bar.classList.remove('is-pop'); void bar.offsetWidth; bar.classList.add('is-pop'); }
    });
  }
  function refreshShip() {
    var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(renderShip).catch(function () {});
  }
  function bumpCart() {
    var ic = $('#header-component a[href$="/cart"], #header-component cart-icon, #header-component .header-actions__cart-icon');
    if (!ic || reduce) return;
    ic.classList.remove('zv-bump'); void ic.offsetWidth; ic.classList.add('zv-bump');
  }
  function setupCart() {
    var onUpdate = function () { setTimeout(refreshShip, 450); bumpCart(); };
    d.addEventListener('cart:update', onUpdate);
    d.addEventListener('cart:updated', onUpdate);
    var dlg = $('cart-drawer-component dialog, dialog.cart-drawer, .cart-drawer dialog, .cart-drawer__dialog');
    if (dlg && 'MutationObserver' in w) {
      new MutationObserver(function () { if (dlg.hasAttribute('open')) refreshShip(); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    var main = $('#MainContent');
    if (main && main.getAttribute('data-template') === 'cart') refreshShip();
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || d;
    if (!reduce && !design) {
      $$('.zv-h2, [data-zv-split-auto]', scope).forEach(function (h) { if (splitWords(h) || h.hasAttribute('data-zv-split')) observe(h); });
      $$('#MainContent .shopify-section h2', scope).forEach(function (h) {
        if (h.closest('.zv-hm, .zv-st, .zv-sc, .zv-fm, product-card, .product-card, dialog')) return;
        if (splitWords(h)) observe(h);
      });
      $$('.zv-split__media', scope).forEach(function (m) { m.setAttribute('data-zv-wipe', ''); observe(m); });
      $$('product-card, .product-card', scope).forEach(function (c) {
        if (c.classList.contains('zv-card-anim') || c.closest('dialog, header, predictive-search-component, .predictive-search')) return;
        c.classList.add('zv-card-anim'); observe(c);
      });
      $$('.zv-fm__word, .zv-sc__card, .zv-pp__item', scope).forEach(function (el) {
        if (el.classList.contains('zv-sc__card') || el.classList.contains('zv-pp__item')) el.classList.add('zv-card-anim');
        observe(el);
      });
    }
    initHero(scope); initShowcase(scope); initStatement(scope); initMarquee(scope);
    initTilt(scope); initMagnetic(scope); initParallax(scope); initProduct(scope); initTopBtn(scope);
  }

  function boot() {
    pickScroller();
    lastY = getY();
    init(d);
    initCursor(); initLenis(); setupCart(); frame();
    var main = $('#MainContent'), pend = null;
    if (main && 'MutationObserver' in w) {
      new MutationObserver(function () { clearTimeout(pend); pend = setTimeout(function () { init(main); }, 180); }).observe(main, { childList: true, subtree: true });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); frame(); });
})();
